// components/StackedBarChart.tsx

import React from 'react';
import Chart from 'react-apexcharts';

interface BarChartProps {
    categories: string[];
    series: ApexAxisChartSeries;
    colors?: string[];
    title?: string;
    yTitle?: string;
    height?: number;
    markersSize?: number;
    toastSuffix?:string;
}
const formatYAxis = (val: any) => {
    if (val >= 1000000) {
        // Million
        return (val / 1000000).toFixed(val % 1000000 === 0 ? 0 : 1) + 'M';
    } else if (val >= 100000) {
        // Lakh
        return (val / 100000).toFixed(val % 100000 === 0 ? 0 : 1) + 'L';
    } else if (val >= 1000) {
        // Thousand
        return (val / 1000).toFixed(val % 1000 === 0 ? 0 : 1) + 'k';
    }
    return val.toString();
};
const ApexLineChart: React.FC<BarChartProps> = ({
    categories,
    series,
    colors,
    title = '',
    height = 300,
    markersSize = 0,
    toastSuffix=''
}) => {
    const options: ApexCharts.ApexOptions = {
        chart: {
            type: 'line',
            toolbar: { show: false },
            zoom: { enabled: false },
            animations: { enabled: true, speed: 800 },
        },
        xaxis: {
            categories: categories,
            labels: {
                formatter: (val) => `${val}`,
            },
        },
        yaxis: {
            labels: {
                formatter: (val: number) => formatYAxis(val), // ✅ Use custom formatter
            },
        },
        stroke: {
            curve: 'smooth',
            width: 1,
        },
        dataLabels: { enabled: false },
        markers: {
            size: 3,
            hover: { sizeOffset: 4 },
        },
        tooltip: {
            enabled: true,
            x: { 
               formatter: (_val, opts) => categories[opts.dataPointIndex], // ✅ fixed

             },
            y: {
                formatter: (val: number | string) => formatYAxis(`${val} ${toastSuffix}`), // ✅ Tooltip also uses same format
            },
        },
        grid: {
            show: true,
            borderColor: '#BFBFBF',
            strokeDashArray: 4,
        },
        colors: colors,
    };


    return <Chart options={options} series={series} type="line" height={height} />;
};

export default ApexLineChart;

